import React, { Fragment } from 'react';
import { credentials } from '@shootsta/client-auth';
import { getStringValueFromGenericInput } from '@shootsta/get-value-from-generic-input';
import cx from 'classnames';
import { Image, Dropdown, Icon, Button } from '../../../../../ui-kit';

import ContentLoader from '../../../../ContentLoader';
import { getRoles, getSelectedRole } from '../../../utils';
import '../styles/_collaborators-list.scss';


















const CollaboratorsList = ({
  listItems = [],
  type,
  onAddMember,
  onUpdateMember,
  onRemoveMember,
  loading = false,
  membersIds = [],
  roles = []
}) => {
  const { user: { userId: currentUserId = '' } = {} } = credentials.get();

  const getEmptyText = () => {
    if (!listItems) {
      return `Search for the ${type} that you want to add as collaborators`;
    }
    return `No ${type} found`;
  };

  const handleButtonClick = (item) => {
    if (!onAddMember) return;
    onAddMember(item);
  };

  const changeAccessPermission = (item) => (result) => {
    if (!onUpdateMember) return;

    const selectedRole = roles.find(
      ({ description }) => description === getStringValueFromGenericInput(result)
    );
    const updatedItem = { ...item, role: selectedRole };

    onUpdateMember(item.draftMemberId, updatedItem);
  };

  const renderListItem = (item) => {
    const isMembersTab = type === 'members';
    const {
      draftMemberId,
      userId,
      teamId,
      imageUrl,
      firstName = '',
      lastName = '',
      name,
      email = '',
      userEmail,
      role,
      type: authorityType = [],
      membersCount
    } = item;
    const displayName = name || `${firstName} ${lastName}`;

    const typeMapping = {
      DRAFT: 'Briefing Assistance',
      SIGN_OFF_FINAL: 'Final Sign-off',
      DEFAULT_COLLABORATORS: 'Default Collaborator'
    };

    const mapTypesToDisplay = authorityType.
    map((ele) => typeMapping[ele.trim()] || ele).
    join(', ');

    const isMember = ['draftMemberId', 'role'].every((prop) => prop in item);

    const isAuthority = 'type' in item && item.type.length;

    const areBoth = isAuthority && isMember;

    return (
      <Fragment key={userId}>
        <div className="collaborators-list-v5__item">
          <div className="collaborators-list-v5__item__image">
            <Image
              imageUrl={imageUrl}
              placeholderText={displayName}
              width="40px"
              height="40px"
              circular
              placeholderTextSize={14} />

          </div>
          <div className="collaborators-list-v5__item__info">
            <p className="collaborators-list-v5__item__info__primary">
              {`${displayName}${userId === currentUserId ? ' (you)' : ''}`}
            </p>
            <p className="collaborators-list-v5__item__info__secondary">
              {userId ?
              isAuthority && userEmail || email :
              `MEMBERS: ${membersCount ?? 0}`}
            </p>
          </div>
          <div
            className={cx('collaborators-list-v5__item__right-container', {
              'collaborators-list-v5__item__right-container__add': !isMembersTab
            })}>

            {isMembersTab ?
            <div className="collaborators-list-v5__item__right-container__authority">
                {isAuthority && <p>{mapTypesToDisplay}</p>}
                {(areBoth || isMember) &&
              <Dropdown
                key={`${draftMemberId || userId || ''}-${role?.name}`}
                className="collaborators-list-v5__item__right-container__role-dropdown"
                type="BASIC"
                onChange={changeAccessPermission(item)}
                defaultValue={getSelectedRole(role, roles)}
                options={getRoles(roles)} />}


              </div> :

            <Button
              className="collaborators-list-v5__item__right-container__button"
              onClick={() => handleButtonClick(item)}
              type="PRIMARY"
              disabled={membersIds.includes(userId || teamId)}>

                {membersIds.includes(userId || teamId) ?
              'Added' :
              `Add ${type === 'users' ? 'User' : 'Team'}`}
              </Button>}

            {isMembersTab && (areBoth || isMember) &&
            <Icon
              name="close"
              size={15}
              onClick={onRemoveMember && onRemoveMember(draftMemberId)}
              className={cx(
                'collaborators-list-v5__item__right-container__remove-icon'
              )}
              color="nevada"
              hoverColor="black" />}


          </div>
        </div>
      </Fragment>);

  };

  const renderLoadingItem = () =>
  <div className="collaborators-list-v5__loading">
      <ContentLoader height={75} width={600} viewBox={null}>
        <rect x="0" y="0" rx="0" ry="0" width={75} height={75} />
        <rect x="90" y="32" rx="0" ry="0" width={600} height={15} />
      </ContentLoader>
    </div>;


  if (loading) {
    return (
      <div className="collaborators-list-v5">
        {renderLoadingItem()}
        <hr className="collaborators-list-v5__horizontal-line" />
        {renderLoadingItem()}
        <hr className="collaborators-list-v5__horizontal-line" />
        {renderLoadingItem()}
      </div>);

  }

  return (
    <div className="collaborators-list-v5">
      {!listItems || !listItems.length ?
      <div className="collaborators-list-v5__empty">
          <p className="collaborators-list-v5__empty__text">{getEmptyText()}</p>
        </div> :

      listItems.map(renderListItem)}

    </div>);

};

export default CollaboratorsList;